import React from 'react';

import './_section-cta.scss';
import LOGO from "../../static/logo-s.svg";

var divStyle = {
  backgroundImage: 'url(' + LOGO + ')'
};


const CtaListing = props =>
  
(<section className="section-cta" style={divStyle}>
    <div className="container">
	      <div className="row">
	        <div className="col-12 text-center">
	        	<p className="lead">{props.data.title} </p>
	        	
	        	<button className="btn" id="getSolutions">{props.data.parts[0].title}</button>
	        </div>
		</div>
		
    </div>
  </section>)
  

export default CtaListing;



// WEBPACK FOOTER //
// ./src/components/section-cta/index.js